import { jsx } from "react/jsx-runtime";
import assert from "assert";
import { Modal } from "../private/Modal/Modal.mjs";
const validWidths = ["small", "medium", "large"];
const validPositions = ["left", "right"];
const defaultWidth = "medium";
const defaultPosition = "right";
const modalStyle = {
  headingLevel: "2",
  illustration: void 0
};
const Drawer = ({
  width = defaultWidth,
  position = defaultPosition,
  ...restProps
}) => {
  assert(validWidths.indexOf(width) >= 0, `Invalid width: ${width}`);
  assert(
    validPositions.indexOf(position) >= 0,
    `Invalid position: ${position}`
  );
  return /* @__PURE__ */ jsx(Modal, { width, position, ...restProps, ...modalStyle });
};
export {
  Drawer
};
